import React from 'react';
import { SubscriptionDetailsTab } from './components/tabs/SubscriptionDetailsTab';
import BasicTabs from '../../common/basic-tabs/BasicTabs';
import { useTranslation } from 'react-i18next';
import { Typography, Stack, Box } from '@mui/material';
import styles from './Settings.module.scss';

const SettingsPage = () => {
  const { t } = useTranslation();
  const tabs = [t('settings.titles.plan')];
  const tabContents = [<SubscriptionDetailsTab key={0} />];
  return (
    <>
      <Box sx={{ mt: '-100px' }}>
        <Box sx={{ pt: '32px !important' }}>
          <Stack spacing={0} sx={{ width: '50%', marginBottom: '20px' }}>
            <Typography variant='h5' component='h1' className={styles.page_title}>
              {t('headers.settings')}
            </Typography>
          </Stack>
        </Box>
        <BasicTabs tabs={tabs} tabContents={tabContents} />
      </Box>
    </>
  );
};
export default SettingsPage;
